import styled from 'styled-components';

export const ContainButton = styled.div`
  display: flex;
  margin-top: 27px;
`;

export const ContainerOrdenacao = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const IconOrdenacao = styled.div`
  opacity: 20%;
  &:hover {
    opacity: 100%;
  }
`;
